/* ---------------------------------------------------------------------------------------------
   DC FILTER BAR (PM-873)

   Does four small things. Filtering itself needs none of this: the chips are real checkboxes inside
   the theme's own facet-form, so ticking one fires the existing AJAX path with no help from here.

   1. Shows the fade and arrow at each end of the rail only when there is something that way.
   2. Steps the rail one whole group per arrow tap.
   3. Opens a held-back group in place when its count is tapped.
   4. Routes sort through the same form as the filters, so a sort survives every later filter click.

   Everything is delegated from document because the facet:update handler replaces the whole section
   on every filter change, which destroys this bar and builds a new one. For the same reason the
   rail scroll position and any opened group are remembered and restored, otherwise a shopper who
   scrolls to Colour, taps a swatch, and gets thrown back to the start of the row.

   Spec: Website/Filter Redesign/pm873-v28-build-spec.md
--------------------------------------------------------------------------------------------- */

(function () {
  'use strict';

  var BAR = '[data-dc-filter-bar]';
  var memory = {};

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function keyFor(bar) {
    var section = bar.closest('.shopify-section');
    return section ? section.id : 'dc-fb';
  }

  function updateEdges(wrap) {
    if (!wrap) return;
    var rail = wrap.querySelector('[data-dc-rail]');
    if (!rail) return;
    var span = rail.scrollWidth - rail.clientWidth;
    wrap.classList.toggle('is-scrollable-next', span > 2 && rail.scrollLeft < span - 2);
    wrap.classList.toggle('is-scrollable-prev', span > 2 && rail.scrollLeft > 2);
  }

  function refreshAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-dc-railwrap]'), updateEdges);
  }

  function remember(bar) {
    if (!bar) return;
    var rail = bar.querySelector('[data-dc-rail]');
    var open = [];
    Array.prototype.forEach.call(bar.querySelectorAll('.dc-fb__group.is-open'), function (group) {
      if (group.dataset.dcGroup) open.push(group.dataset.dcGroup);
    });
    memory[keyFor(bar)] = { scrollLeft: rail ? rail.scrollLeft : 0, open: open };
  }

  function restore(bar) {
    var saved = memory[keyFor(bar)];
    if (!saved) return;
    saved.open.forEach(function (param) {
      var group = bar.querySelector('[data-dc-group="' + param + '"]');
      if (group) group.classList.add('is-open');
    });
    var rail = bar.querySelector('[data-dc-rail]');
    if (rail) rail.scrollLeft = saved.scrollLeft;
  }

  /* One arrow tap moves one whole group, so a thumb never has to land on a chip to move the row. */
  function step(bar, direction) {
    var rail = bar.querySelector('[data-dc-rail]');
    if (!rail) return;
    var pad = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
    var stops = Array.prototype.filter.call(rail.children, function (el) {
      return el.classList.contains('dc-fb__group') || el.classList.contains('dc-fb__stock');
    });
    var current = rail.scrollLeft;
    var target;

    if (direction > 0) {
      var next = null;
      stops.forEach(function (s) {
        if (next === null && s.offsetLeft - pad > current + 8) next = s;
      });
      target = next ? next.offsetLeft - pad : rail.scrollWidth;
    } else {
      var prev = null;
      stops.forEach(function (s) {
        if (s.offsetLeft - pad < current - 8) prev = s;
      });
      target = prev ? prev.offsetLeft - pad : 0;
    }

    rail.scrollTo({ left: target, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var more = target.closest('[data-dc-more]');
    if (more) {
      var group = more.closest('.dc-fb__group');
      if (group) group.classList.add('is-open');
      remember(more.closest(BAR));
      refreshAll();
      return;
    }

    var edge = target.closest('[data-dc-step]');
    if (edge) {
      var bar = edge.closest(BAR);
      if (bar) step(bar, parseInt(edge.getAttribute('data-dc-step'), 10));
      return;
    }

    var sortButton = target.closest('[data-dc-sort]');
    if (sortButton) {
      var sortBar = sortButton.closest(BAR);
      if (!sortBar) return;
      var input = sortBar.querySelector('[data-dc-sort-input]');
      if (!input) return;

      var value = sortButton.getAttribute('data-dc-sort');
      var isPrice = sortButton.hasAttribute('data-dc-sort-price');

      if (isPrice) {
        /* Price is one button that flips, matching the mockup, rather than two rows. */
        value = input.value === 'price-ascending' ? 'price-descending' : 'price-ascending';
      } else if (input.value === value) {
        return;
      }

      input.value = value;
      remember(sortBar);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* scroll does not bubble, so this listens in the capture phase */
  document.addEventListener('scroll', function (event) {
    var rail = event.target;
    if (!rail || rail.nodeType !== 1 || !rail.hasAttribute || !rail.hasAttribute('data-dc-rail')) return;
    updateEdges(rail.parentElement);
    remember(rail.closest(BAR));
  }, true);

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll(BAR), function (bar) {
      restore(bar);
      updateEdges(bar.querySelector('[data-dc-railwrap]'));

      var section = bar.closest('.shopify-section');
      if (section && !section.dcFilterBarObserved) {
        section.dcFilterBarObserved = true;
        /* the facet:update handler calls replaceChildren on the section, so this fires on every
           filter or sort change and hands the rail its scroll position back */
        new MutationObserver(function () {
          requestAnimationFrame(function () {
            Array.prototype.forEach.call(document.querySelectorAll(BAR), restore);
            refreshAll();
          });
        }).observe(section, { childList: true });
      }
    });
    refreshAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', refreshAll);
  document.addEventListener('shopify:section:load', init);

  /* the display face loads late and changes every measurement in the row */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(refreshAll);
  }
  setTimeout(refreshAll, 900);
})();
